import { css } from '@emotion/react';

import Image from 'next/image';

import { FullscreenModalProps } from '@components/common/FullscreenModal';
import Overlay from '@components/common/Overlay';

import { IEFinderObject } from '@model';
import { safeArea } from '@styles/css';

type Props = Omit<FullscreenModalProps, 'title'>;

const containerCSS = css`
  background-color: rgba(0, 0, 0, 0.8) !important;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  ${safeArea('top', 'padding')};
  ${safeArea('bottom', 'padding')};
`;

const imageContainerCSS = css`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: scroll;

  img {
    max-width: 100%; /* width는 화면에 맞게 채움 */
    max-height: 100%; /* height는 초과하지 않도록 제한 */
    object-fit: contain; /* 비율 유지하며 width 채움 */
  }
`;

type ImageModalProps = {
  image: IEFinderObject<'image'>;
};

const ImageModal = ({ image, ...props }: Props & ImageModalProps) => {
  const { onClose, open } = props;
  if (!open) {
    return <></>;
  }

  return (
    <Overlay
      {...props}
      blocking={false}
      css={containerCSS}
      onClosePageClick={onClose}
    >
      <div css={imageContainerCSS}>
        <Image
          src={image.attachment.url}
          alt={'ground-image'}
          layout={'intrinsic'}
          loader={({ src }) => src}
          width={image.attachment.width}
          height={image.attachment.height}
          objectPosition={'center'}
          objectFit={'contain'}
        />
      </div>
    </Overlay>
  );
};

export default ImageModal;
